/**
 * PDF Worker 工具函数
 * 用于动态获取PDF worker文件的版本号
 */

// 声明全局变量类型
declare global {
  const __APP_VERSION__: string
}

// 获取应用版本号
export function getAppVersion(): string {
  // 在构建时，Vite会将__APP_VERSION__替换为实际的版本号
  return typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '1.1.54'
}

// 获取PDF worker的URL，包含版本号
export function getPdfWorkerUrl(): string {
  const version = getAppVersion()
  return new URL(
    `pdfjs-dist/build/pdf.worker.mjs?v=${version}`,
    import.meta.url
  ).toString()
}
